import React, { Fragment, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'styled-components'

import { axios } from 'api'
import { Button, Flex, P } from 'ui/bend'

const InactiveMembership = ({ handleError }) => {
  const [status, setStatus] = useState()
  // We need to manually set the color of buttons acting as anchor tags in legacy components, due to style sheets overriding one another.
  const { colors } = useTheme()

  useEffect(() => {
    const fetchMembershipStatus = async () => {
      try {
        const res = await axios.get('/users/me/membership/latest')
        if (res) {
          setStatus(res.data.status)
        }
      } catch (error) {
        handleError(error)
      }
    }

    fetchMembershipStatus()
  }, [])

  const handleTemporaryAccess = async () => {
    try {
      const res = await axios.post('/users/me/membership/should_have_access')
      if (res) {
        window.location.href = '/'
      }
    } catch (error) {
      handleError(error)
    }
  }

  return (
    <Flex flexDirection='column' alignItems='center'>
      {status && status === 'unknown' ? (
        <Fragment>
          <P color='primary' textAlign='center'>
            We are having a problem accessing your account details. Please click
            below to gain access.
          </P>
          <Button onClick={handleTemporaryAccess}>Gain Temporary Access</Button>
        </Fragment>
      ) : (
        <Fragment>
          <P color='primary' textAlign='center'>
            You do not have an active Alo Moves Membership.
          </P>
          <Button
            className='unstyled'
            as='a'
            href='/subscribe'
            style={{ color: colors.base }}
          >
            Sign Up
          </Button>
        </Fragment>
      )}
    </Flex>
  )
}

InactiveMembership.propTypes = {
  handleError: PropTypes.func.isRequired
}

export default InactiveMembership
